import React, { useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { Eye } from "lucide-react";
import { AgGridReact } from "ag-grid-react";
import Button from "../../../components/Button";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "./styles.css";

export function ScheduledWorkflowsTable({ workflowId, scheduledWorkflows }) {
  const navigate = useNavigate();
  const [, setGridApi] = useState(null);

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      resizable: false,
      sortingOrder: ["desc", "asc", null],
    }),
    []
  );

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        initialWidth: 240,
        resizable: true,
      },
      {
        headerName: "Created",
        field: "created_at",
        initialWidth: 500,
        resizable: true,
        valueFormatter: (params) =>
          format(parseISO(params.value), "MMMM do, yyyy"),
      },
      {
        headerName: "",
        field: "actions",
        initialWidth: 240,
        resizable: true,
        sortable: false,
        cellRenderer: (params) => (
          <div className="flex justify-end items-center">
            <Button
              label={<Eye size={17} />}
              onClick={() => {
                navigate(
                  `/workflows/${workflowId}/scheduled/${params.data.id}/runs`
                );
              }}
              variant="secondary"
            />
          </div>
        ),
      },
    ],
    [workflowId, navigate]
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);

  const defaultSortModel = [{ colId: "created_at", sort: "desc" }];

  return (
    <div className="flow-root">
      <h2 className="text-lg font-semibold text-gray-700 mb-2">Variants</h2>

      <p className="text-sm font-semibold text-gray-400 mb-1">
        Scheduled workflows have "variants". Each variant is an instance of the
        scheduled workflow, each with their own context object. For a scheduled
        workflow to work, it has to have a variant with a context object that it
        can use to complete the task.
      </p>

      <div className="ag-theme-quartz ag-theme-rectangle">
        <AgGridReact
          columnDefs={columnDefs}
          rowData={scheduledWorkflows}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          domLayout="autoHeight"
          animateRows={true}
          defaultSortModel={defaultSortModel}
        />
      </div>
    </div>
  );
}
